//state用于存储状态,变量
const state = {
    user:window.sessionStorage.getItem('user')?JSON.parse(window.sessionStorage.getItem('user')):{},
    authorization: localStorage.getItem('Authorization')?localStorage.getItem('Authorization'):''
}

export  default state